export default __webpack_public_path__ + "static/media/trafficControl1.8a263912.png";